import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Head } from '../../components/Head';
import { selectBuilderInfo } from '../../selectors/builder';
import { trackShowPhoneClick } from '../../utils/tracking';
import { PhoneButtonContainer } from '../PhoneButtonContainer';
import { BreadcrumbsContainer } from '../BreadcrumbsContainer';
import { CallbackButtonContainer } from '../CallbackButtonContainer';
import { ECallbackWidgetPlacement } from '../../types/callbackWidget';

export const HeadContainer = () => {
  const builderInfo = useSelector(selectBuilderInfo);

  const handleShowPhone = useEventCallback(() => {
    trackShowPhoneClick(builderInfo.id);
  });

  return (
    <Head
      {...builderInfo}
      breadcrumbs={<BreadcrumbsContainer placement="header" />}
      phoneButton={<PhoneButtonContainer text="Показать контакты" size="M" onShow={handleShowPhone} />}
      callbackButton={<CallbackButtonContainer placement={ECallbackWidgetPlacement.Head} />}
    />
  );
};
